import { GoogleMap, LoadScript } from "@react-google-maps/api";

import { useState, useEffect } from "react";
import MapControls from "../../components/MapControls";
import PriceOverlayView from "../../components/PriceOverlayView";

const locations = [
  {
    lat: 14.36534955929991,
    lng: 44.191190868315964,
  },
  {
    lat: 15.36534955929991,
    lng: 44.191190868315964,
  },
  {
    lat: 14.99835602,
    lng: 45.01502627,
  },
  {
    lat: 11.99835602,
    lng: 45.01502627,
  },
  {
    lat: 12.99835602,
    lng: 45.01502627,
  },
  {
    lat: 14.99835602,
    lng: 40.01502627,
  },
];

const SessionsMap = ({ map, setMap }) => {
  const [center, setCenter] = useState(locations[0]);
  const [currentPriceOverlayViewRef, setCurrentPriceOverlayViewRef] =
    useState(null);

  useEffect(() => {
    console.log(map);
    map && map.panTo(center);
  }, []);

  const googleMapProps = {
    center: center,
    zoom: 11,
    mapContainerClassName: "h-[100vh] w-full",
    onLoad: (map) => setMap(map),
    options: {
      clickableIcons: false,
      disableDefaultUI: true,
      gestureHandling: "greedy",
    },
  };

  const mapTo = (location) => {
    map.panTo(location);
  };

  return (
    <div className="relative">
      <LoadScript>
        {map && <MapControls map={map} />}
        <GoogleMap {...googleMapProps}>
          {locations.map((location, index) => {
            return (
              <PriceOverlayView
                key={index}
                center={location}
                mapTo={mapTo}
                currentPriceOverlayViewRef={currentPriceOverlayViewRef}
                setCurrentPriceOverlayViewRef={setCurrentPriceOverlayViewRef}
                setCenter={setCenter}
              />
            );
          })}
        </GoogleMap>
      </LoadScript>
    </div>
  );
};

export default SessionsMap;
